export class KeyValue {
    key: string
    value: string
}